module.exports = __webpack_public_path__ + "static/media/Terms_of_Business_v1.1.402d9d87.pdf";